import { RtlLocales, Direction } from './constants';
export function resolveLocaleDirection(udemyLocale) {
  return RtlLocales.includes(udemyLocale) ? Direction.RTL : Direction.LTR;
}
//# sourceMappingURL=resolve-locale-direction.js.map